export const checkCookie = (cookieName: string): boolean => {
  return (
    document.cookie.split(';').filter((item) => item.trim().startsWith(`${cookieName}=`)).length > 0
  );
};

export const cookieValue = (cookieName: string): string | undefined => {
  const b = document.cookie?.match(`(^|[^;]+)\\s*${cookieName}\\s*=\\s*([^;]+)`);
  return b ? b.pop() : '';
};

declare global {
  interface Window {
    _satellite?: { getVar: (name: string) => string | undefined };
  }
}

export const getEcid = (): string => {
  return window._satellite?.getVar('getECID') ?? '';
};

export enum CookieName {
  PARTNERSHIP_AZURE_B2C = 'a3f5b2c1-4d8e-4a9b-b5c3-7f2e1a9d6c4b_PP_Auth',
  B2CW = 'JwtAuthToken',
}
